import './modal.scss';

import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from './actions';
import Modal from 'components/ui/modal';
import View from 'components/ui/view';
import Text from 'components/ui/text';
import LoginForm from './login';
import ForgotForm from './forgot';
import SignupWithPromo from './signupWithPromo';

let AuthModal = class AuthModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = { postSignup: null };

    this.closeDropDown = this.closeDropDown.bind(this);
    this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
    this.handleLoginSuccess = this.handleLoginSuccess.bind(this);
    this.showLogin = this.changeLoginView.bind(this, 'login');
    this.showForgot = this.changeLoginView.bind(this, 'forgot');
    this.showSignup = this.changeLoginView.bind(this, 'signup');
  }

  changeLoginView(view) {
    this.props.showLogin(view);
  }

  closeDropDown() {
    this.props.showLogin(false);
  }

  handleLoginSubmit(user) {
    return this.props
      .login({ username: user.email, password: user.password })
      .then(() => {
        if (this.reloadOnSignup()) window.location.reload();
      });
  }

  handleLoginSuccess() {
    this.props.showLogin(false);
  }

  reloadOnSignup() {
    // HACKY: If signing up on gifting page, reload to get server-generated shopper token
    return window.location.pathname === '/gifting';
  }

  render() {
    return (
      <Modal
        className="login-modal"
        isOpen={!!this.props.display}
        handleClose={this.closeDropDown}
      >
        {this.props.display === 'signup' && (
          <div className="login-modal__form">
            <SignupWithPromo
              compact
              reloadOnSignup={this.reloadOnSignup()}
              shopNow={this.closeDropDown}
            />

            {_.isEmpty(this.props.user) && (
              <div className="login-modal__footer">
                <div className="text-right">
                  <small>
                    Already have an account?{' '}
                    <a className="link-text" onClick={this.showLogin}>
                      Log in
                    </a>.
                  </small>
                </div>
              </div>
            )}
          </div>
        )}

        {this.props.display === 'login' && (
          <div className="login-modal__form">
            <View padding={{ top: 'md', sides: 'sm', bottom: 'sm' }}>
              <Text display tag="h1" size="xxl" weight="med" margin="none">
                Welcome Back
              </Text>
            </View>

            <View padding={{ sides: 'sm', bottom: 'md' }}>
              <LoginForm
                showForgotPassword={this.showForgot}
                onSubmit={this.handleLoginSubmit}
                onSuccess={this.handleLoginSuccess}
              />
            </View>

            <div className="login-modal__footer">
              <div className="text-right">
                <small>
                  Don{"'"}t have an account?{' '}
                  <a className="link-text" onClick={this.showSignup}>
                    Sign up
                  </a>.
                </small>
              </div>
            </div>
          </div>
        )}

        {this.props.display === 'forgot' && (
          <div className="login-modal__form">
            <View padding={{ top: 'md', sides: 'sm', bottom: 'sm' }}>
              <Text display tag="h1" size="xxl" weight="med" margin="none">
                Forgot Password
              </Text>
            </View>

            <View padding={{ sides: 'sm', bottom: 'sm' }}>
              <ForgotForm showLogin={this.showLogin} />
            </View>

            <div className="login-modal__footer">
              <div className="text-right">
                <small>
                  Don{"'"}t have an account?{' '}
                  <a className="link-text" onClick={this.showSignup}>
                    Sign up
                  </a>.
                </small>
              </div>
            </div>
          </div>
        )}
      </Modal>
    );
  }
};

AuthModal = connect(
  state => ({
    ...state.login,
    userPromo: state.promo
  }),
  { ...actions }
)(AuthModal);

export default AuthModal;



// WEBPACK FOOTER //
// ./shared/components/login/modal.js